import React from 'react';
import { Link } from 'react-router-dom';
import Chevron from '../components/content/Chevron';
import { useWebLocale } from '../contexts/WebLocaleContext';
import baseline, { appTextStyle } from './baseline';
import './AppContent.css';

// Source-backed title/subtitle and navigation branches. Native accessories remain unported.
export function AppSectionHeading({ title, subtitle, to, inlineMore = false }) {
  const { t } = useWebLocale();
  const { section, tokens, contentText } = baseline;
  const label = `${title}${subtitle ? ` ${subtitle}` : ''} · ${t('more')}`;
  const chevron = <Chevron className="pp-app-section-chevron" />;
  return (
    <div className="pp-app-section-heading" style={{ minHeight: section.header.minHeight }}>
      <div className="pp-app-section-title-row" style={{ gap: section.titleRow.gap }}>
        <h2 style={appTextStyle(tokens.typography.sectionTitle)}>
          {to ? (
            <Link className="pp-app-section-title-link" to={to} aria-label={label}>
              {title}
              {inlineMore && chevron}
            </Link>
          ) : (
            title
          )}
        </h2>
        {subtitle && <span style={appTextStyle(contentText.metadata)}>{subtitle}</span>}
      </div>
      {to && !inlineMore && (
        <Link className="pp-app-section-more" to={to} aria-label={label}>
          {chevron}
        </Link>
      )}
    </div>
  );
}
export default function AppContentSection({ title, subtitle, to, inlineMore = false, children }) {
  return (
    <section
      className="pp-discovery-section pp-app-section"
      style={{ gap: baseline.section.section.gap }}
    >
      <AppSectionHeading title={title} subtitle={subtitle} to={to} inlineMore={inlineMore} />
      {children}
    </section>
  );
}
